import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './login_button.less'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/login_button')

class LoginButton extends React.Component {
  static propTypes = {
    loggedIn: PropTypes.bool,
    displayName: PropTypes.string,
    type: PropTypes.oneOf(['dark', 'light', 'transparent']),
    loginUrl: PropTypes.string,
    logoutUrl: PropTypes.string,
    stayOnPageOnLogout: PropTypes.bool,
  }

  render() {
    return (
      <span>
        {this.props.loggedIn && (
          <span styleName={`display-name-${this.props.type}`}>
            {this.props.displayName}
          </span>
        )}
        <a
          data-pa-click={this.props.loggedIn ? 'logout' : 'login'}
          href={
            this.props.loggedIn ? this.props.logoutUrl : this.props.loginUrl
          }
          styleName={this.props.loggedIn ? 'logout-button' : 'login-button'}
          className={`vx_btn vx_btn-secondary${
            this.props.type === 'light' ? '' : '_reversed'
          } vx_btn-small`}
        >
          {i18n(this.props.loggedIn ? 'log_out' : 'log_in')}
        </a>
      </span>
    )
  }
}

export default cssModules(LoginButton, styles)
